import React, { Component } from 'react';
import createSinglePlayer from '../singlePlayer.js';
import { callPlayer, getSDK } from '../utils.js';
import '../Player.js';
import '../props.js';
import 'prop-types';
import 'lodash';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const SDK_URL = "https://fast.wistia.com/assets/external/E-v1.js";
const SDK_GLOBAL = "Wistia";
const MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;
class Wistia extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "callPlayer", callPlayer);
    // Proxy methods to prevent listener leaks
    __publicField(this, "onPlay", (...args) => this.props.onPlay(...args));
    __publicField(this, "onPause", (...args) => this.props.onPause(...args));
    __publicField(this, "onSeek", (...args) => this.props.onSeek(...args));
    __publicField(this, "onEnded", (...args) => this.props.onEnded(...args));
    __publicField(this, "mute", () => {
      this.callPlayer("mute");
    });
    __publicField(this, "unmute", () => {
      this.callPlayer("unmute");
    });
  }
  getID(url) {
    return url && url.match(MATCH_URL)[1];
  }
  load(url) {
    const { playing, muted, controls, onReady, config, onError } = this.props;
    getSDK(SDK_URL, SDK_GLOBAL).then(() => {
      window._wq = window._wq || [];
      window._wq.push({
        id: this.getID(url),
        options: __spreadValues({
          autoPlay: playing,
          silentAutoPlay: "allow",
          muted,
          controlsVisibleOnLoad: controls
        }, config.wistia.options),
        onReady: (player) => {
          this.player = player;
          this.unbind();
          this.player.bind("play", this.onPlay);
          this.player.bind("pause", this.onPause);
          this.player.bind("seek", this.onSeek);
          this.player.bind("end", this.onEnded);
          onReady();
        }
      });
    }, onError);
  }
  unbind() {
    this.player.unbind("play", this.onPlay);
    this.player.unbind("pause", this.onPause);
    this.player.unbind("seek", this.onSeek);
    this.player.unbind("end", this.onEnded);
  }
  play() {
    this.callPlayer("play");
  }
  pause() {
    this.callPlayer("pause");
  }
  stop() {
    this.unbind();
    this.callPlayer("remove");
  }
  seekTo(seconds) {
    this.callPlayer("time", seconds);
  }
  setVolume(fraction) {
    this.callPlayer("volume", fraction);
  }
  setPlaybackRate(rate) {
    this.callPlayer("playbackRate", rate);
  }
  getDuration() {
    return this.callPlayer("duration");
  }
  getCurrentTime() {
    return this.callPlayer("time");
  }
  getSecondsLoaded() {
    return null;
  }
  render() {
    const id = this.getID(this.props.url);
    const className = `wistia_embed wistia_async_${id}`;
    const style = {
      width: "100%",
      height: "100%"
    };
    return /* @__PURE__ */ React.createElement("div", { key: id, className, style });
  }
}
__publicField(Wistia, "displayName", "Wistia");
__publicField(Wistia, "canPlay", (url) => MATCH_URL.test(url));
__publicField(Wistia, "loopOnEnded", true);
var Wistia$1 = createSinglePlayer(Wistia);

export { Wistia, Wistia$1 as default };
//# sourceMappingURL=Wistia.js.map
